'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../lib/usageTracker';
import { getFreeCtaLink } from '../../constants/TrialConstants';
import LangUtils from '../../util/LanguageUtil';
import Logo from '../Logo';
import footerCmsFree from 'bender-url!../../../img/footerCmsFree.png';
import { parseUtmParams } from '../../util/Urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrialCtaPage = ({
  websiteUrl
}) => {
  const parsedUtmParams = parseUtmParams();
  const lang = LangUtils.getLangKey();
  const handleCtaClick = () => {
    const eventKey = 'academyCourseClick';
    const action = 'clicked-start-free-course-button';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'results-footer'
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: "trial-cta-page",
    "data-reagan-selector": "trial-cta-page",
    children: /*#__PURE__*/_jsx("div", {
      className: "wsg-container trial-cta-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "cta-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "cta-image-left",
          children: /*#__PURE__*/_jsx("img", {
            src: footerCmsFree
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "cta-info-right",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "trial-cta-header",
            children: [/*#__PURE__*/_jsx("div", {
              className: "product-logo",
              children: /*#__PURE__*/_jsx(Logo, {})
            }), /*#__PURE__*/_jsx("div", {
              className: "header",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                className: "header",
                message: "trialCtaPage.header"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "paragraph",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trialCtaPage.cmsParagraph"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "trial-cta-button",
            children: /*#__PURE__*/_jsx("a", {
              className: "button white",
              onClick: handleCtaClick,
              href: `${getFreeCtaLink(lang, 'bottom-cta')}&${parsedUtmParams}`,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "trialBanner.ctaButtonFree"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "microcopy"
          })]
        })]
      })
    })
  });
};
TrialCtaPage.propTypes = {
  websiteUrl: PropTypes.string.isRequired
};
export default TrialCtaPage;